import React from 'react';

export default function BacBlock7CTA() {
  return (
    <section className="py-24 md:py-[160px] px-6 bg-paper text-center" id="contacto">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-[48px] md:text-[48px] lg:text-[64px] font-bold text-ink mb-8 leading-[1.1] tracking-tight">
          Define una población. Nosotros ayudamos a operar lo que debe ocurrir.
        </h2>
        <p className="text-[20px] md:text-[24px] text-ink-soft mb-16 leading-[1.6] max-w-3xl mx-auto">
          Conversemos sobre cómo instalar capacidad operacional en tu red de salud.
        </p>
        <a href="/#contacto" className="inline-block bg-brand text-white hover:bg-brand-deep hover:text-white px-12 py-3 text-[20px] font-semibold tracking-widest rounded-xl transition-colors uppercase focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand">
          CONVERSEMOS
        </a>
      </div>
    </section>
  );
}
